import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/error-descriptions'

/**
 * Mendapatkan daftar error description dengan filter dan paginasi
 * @param {Object} params - Parameter query
 * @param {number} params.page - Halaman
 * @param {number} params.limit - Jumlah data per halaman
 * @param {string} params.search - Pencarian (code, header, body)
 * @param {string} params.type - Filter tipe (info/warn/error)
 * @param {Array} params.filters - Filter tambahan (jika diperlukan)
 * @param {Array} params.sorts - Sorting (contoh: ['created_at desc'])
 * @param {string} region - Kode region (default 'SG')
 */
export const getList = async (params = {}) => {
  const queryParams = {
    page: params.page || undefined,
    limit: params.limit || undefined,
    search: params.search || undefined,
    type: params.type || undefined,
    filters: params.filters || undefined,
    sorts: params.sorts || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: queryParams,
  })

  return response?.data
}

/**
 * Membuat error description baru
 * @param {Object} data - Data error description
 * @param {string} data.code - Kode unik
 * @param {string} data.header - Header (opsional)
 * @param {string} data.subheader - Subheader (opsional)
 * @param {string} data.body - Body (opsional)
 * @param {string} data.footer - Footer (opsional)
 * @param {string} data.type - Tipe (info/warn/error) wajib
 * @param {string} region - Kode region
 */
export const create = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response
}

/**
 * Mengupdate error description berdasarkan code
 * @param {string} code - Kode error description
 * @param {Object} data - Data yang akan diupdate (partial)
 * @param {string} region - Kode region
 */
export const update = async (code, data) => {
  const response = await apiClient({
    method: 'PATCH', // atau 'PATCH' jika API mendukung partial update
    url: `${baseEndpoint}/${code}`,
    data,
  })

  return response
}

/**
 * Mendapatkan detail error description berdasarkan code
 * @param {string} code - Kode error description
 * @param {string} region - Kode region
 */
export const getByCode = async (code) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${code}`,
  })

  return response?.data
}

/**
 * Menghapus satu error description berdasarkan code
 * @param {string} code - Kode error description
 * @param {string} region - Kode region
 */
export const deleteByCode = async (code) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/${code}`,
  })

  return response
}
